"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var markInputRule_1 = __importDefault(require("../lib/markInputRule"));

var Mark_1 = __importDefault(require("./Mark"));

var mark_1 = __importDefault(require("../rules/mark"));

var Highlight =
/*#__PURE__*/
function (_Mark_1$default) {
  _inherits(Highlight, _Mark_1$default);

  function Highlight() {
    _classCallCheck(this, Highlight);

    return _possibleConstructorReturn(this, _getPrototypeOf(Highlight).apply(this, arguments));
  }

  _createClass(Highlight, [{
    key: "inputRules",
    value: function inputRules(_ref) {
      var type = _ref.type;
      return [markInputRule_1.default(/(?:==)([^=]+)(?:==)$/, type)];
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        "Mod-Ctrl-h": prosemirror_commands_1.toggleMark(type)
      };
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        mark: "highlight"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "highlight";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        parseDOM: [{
          tag: "mark"
        }],
        toDOM: function toDOM() {
          return ["mark"];
        }
      };
    }
  }, {
    key: "rulePlugins",
    get: function get() {
      return [mark_1.default({
        delim: "==",
        mark: "highlight"
      })];
    }
  }, {
    key: "toMarkdown",
    get: function get() {
      return {
        open: "==",
        close: "==",
        mixable: true,
        expelEnclosingWhitespace: true
      };
    }
  }]);

  return Highlight;
}(Mark_1.default);

exports.default = Highlight;